<template>
  <v-card class="not-found-page fill-height position-relative">
    <div class="not-found__wrapper text-center mx-auto">
      <img class="not-found__img" :src="$vuetify.theme.isDark ? errorDarkIcon : errorLightIcon" alt="Error 404" />
      <h2 class="not-found__title">{{ $t("custom.not_found_page.title") }}</h2>
      <span class="not-found__message">{{ $t("custom.not_found_page.message") }}</span>
      <div>
        <v-btn class="not-found__btn" color="primary" @click="goHome()">
          <span class="not-found__btn-content"> {{ $t("custom.not_found_page.btn_content") }} </span>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
  const errorLightIcon = require("@/assets/images/svg/404error-light.svg");
  const errorDarkIcon = require("@/assets/images/svg/404error-dark.svg");

  export default {
    data() {
      return {
        errorLightIcon,
        errorDarkIcon,
      };
    },
    methods: {
      goHome() {
        this.$router.push({
          name: "dashboard",
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .not-found {
    &__wrapper {
      font-family: "Roboto";
      width: 450px;
      position: absolute;
      top: calc(50% - 100px);
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &__img {
      margin-bottom: 45px;
    }
    &__title {
      font-weight: 900;
      font-size: 38px;
      line-height: 45px;
      margin-bottom: 12px;
    }
    &__message {
      display: inline-block;
      max-width: 350px;

      margin-bottom: 32px;
    }
    &__btn {
      width: 194px;
      height: 40px;
      &-content {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-transform: none;
        letter-spacing: 0.06em;
      }
    }
  }

  .theme--dark {
    .not-found {
      &__title {
        color: #ffffff !important;
      }
      &__message {
        color: #e8e6f0 !important;
        letter-spacing: 0.06em;
        font-weight: 300;
        font-size: 16px;
      }
    }
  }

  .theme--light {
    .not-found {
      &__title {
        color: #201f37 !important;
      }
      &__message {
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        color: #45404e !important;
      }
    }
  }

  .not-found-page {
    border: none !important;
  }
</style>
